<template>
  <div>
    <footer class="footer">
      <div class="container-fluid">
        <b-row cols="12">
          <b-col>
            <ul class="list-1">
              <li class="li-1">
                <img
                  src="@/assets/image/LogoImperial.jpg"
                  rounded
                  alt="Rounded image"
                  width="75"
                  height="75"
                />
                Imperial - Labs
              </li>
              <li class="li-2">
                Labóratorio de Lentes e Montagem Computadorizada
              </li>
            </ul>
          </b-col>
          <b-col>
            <ul class="list-2">
              <li class="li-2">Tel: (33) 3321-5300</li>
              <li class="li-2">
                Endereço: Travessa Coronel Santos Mestre, número 97, Loja 1,
                Segundo andar, Caratinga MG.
              </li>
            </ul>
          </b-col>
          <b-col>
            <ul class="list-3">
              <li class="li-3">
                <img src="@/assets/image/icons/instagram.png" />
                @imperialoticas_ &nbsp;
              </li>
              <li class="li-3">
                <img src="@/assets/image/icons/whatsapp.png" />
                Lucas (33) 9 9975-7595 &nbsp;
              </li>
              <li class="li-3">
                <img src="@/assets/image/icons/whatsapp.png" />
                Rodrigo (33) 9 8802-3040 &nbsp;
              </li>
            </ul>
          </b-col>
        </b-row>
        <hr />
        <b-row cols="12">
          <b-col>
            <div class="row-1">
              Created by <strong>Ícaro Drumond</strong> and
              <strong>Lucas Felipe</strong>
            </div>
          </b-col>
          <b-col>
            <div class="row-2">
              © Copyright Imperial - Todos os direitos reservados.
            </div>
          </b-col>
        </b-row>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>

<style scoped>
hr {
  margin-top: 0%;
}
.footer {
  background: rgb(42, 99, 179);
  position: absolute;
  bottom: 0;
  width: 100%;
  /*max-height: 10%;*/
}

.list-1 {
  list-style-type: none;
  margin-top: 5%;
  color: rgba(240, 255, 255, 0.7);
}

.li-1 {
  font-size: 16pt;
}

.list-2 {
  list-style-type: none;
  margin-top: 10%;
  color: rgba(240, 255, 255, 0.7);
}

.li-2 {
  margin-top: 1%;
  font-size: 10pt;
}

.list-3 {
  list-style-type: none;
  margin-top: 10%;
  margin-left: 15vw;
  color: rgba(240, 255, 255, 0.7);
}

.li-3 {
  margin-top: 2%;
  font-size: 10pt;
}

.row-1 {
  margin-bottom: 1%;
  font-size: 9pt;
  color: rgba(240, 255, 255, 0.7);
}

.row-2 {
  float: right;
  margin-bottom: 1%;
  font-size: 9pt;
  color: rgba(240, 255, 255, 0.7);
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue